angular.module('meevo.plugins.confirmationManager').controller('confirmationAppointmentHistory', [
    '$scope', '$http', '$rootScope', 'appointmentBookModalService', 'appointmentBookBuilderService', 'appointmentId', "meevo.components.modal.ModalService","restServer",
    function ($scope, $http, $rootScope, modal, builder, appointmentId, modalService, restServer) {
        $scope.modal = modal;
        $scope.modalService = modalService;
        $scope.appointmentId = appointmentId;

        console.log(appointmentId);
        restServer.getConfirmationHistory(appointmentId).then(function(result) {
            $scope.confirmatioHistory = result.data;
        });
        //console.log($scope.confirmatioHistory);

        $scope.hide = function() {
            $scope.modal.hideModal();
        }
    }


]);